import React from 'react'

const useLocalStoreClear = () => {
  const clearLocalStorage = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("expireDate");
      localStorage.removeItem("userInfo");
      localStorage.removeItem("role");
      localStorage.removeItem("permissions");
  };

    return { clearLocalStorage };
}

export default useLocalStoreClear